import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'

import { NEW_SEARCH_TRIGGER_MANUAL, newSearch } from '@/results/store/actions'

import { setSearchState } from '../../search/store/actions'

import MenuItemView from './MenuItemView'

const useClickHandler = (state) => {
  const dispatch = useDispatch()
  return state && ((event) => {
    event.preventDefault()
    dispatch(setSearchState(state, { replace: true }))
    dispatch(newSearch.trigger(state, { trigger: NEW_SEARCH_TRIGGER_MANUAL }))
  })
}

const MenuItem = ({ state, ...props }) => {
  const handleMenuItemClick = useClickHandler(state)
  return <MenuItemView {...props} onClick={handleMenuItemClick} />
}

MenuItem.propTypes = {
  state: PropTypes.object
}

export default MenuItem
